import React, {memo, useState} from "react";

export const S5_VALS = [7, 28, 50, 71, 92]
export const S5_GRAD = [9, 30, 50, 69, 89]

export const S3_VALS = [11, 38, 66]
export const S3_GRAD = [14, 39, 65]


const SteppedSlider = ({value, vals, grads, onChange, ...props}) => {

    const getClosestValueInd = val => {
        let minInd = 0
        let min = Math.abs(val - vals[0])
        for (let i = 1; i < vals.length; ++i){
            const cur = Math.abs(val - vals[i])
            if(cur < min){
                min = cur
                minInd = i
            }
        }
        return minInd
    }

    const handleChange = e => {
        const v = e.target.value;
        const newInd = getClosestValueInd(v)
        if(value !== newInd)
            onChange(newInd)
    }

    const gr = (grads || vals)[value]

    return <input type="range"
                  min="1"
                  max="100"
                  style={{
                      background: `linear-gradient(to right, #484237 0%, #b99c69 ${gr}%, #5a5c55 ${gr}%, #5a5c55 100%)`
                  }}
                  value={vals[value]}
                  onChange={handleChange}
                  {...props}/>
}

export default memo(SteppedSlider)